<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        v-if="inbox && inbox.length > 0"
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <page-title :title="$t('inbox')" />
          <div>
            <div
              v-for="mail in inbox"
              :key="mail.id"
            >
              <mail-line :mail="mail" />
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-else
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <page-title :title="$t('inbox')" />
          <div>
            <h3>Your inbox is empty</h3>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import MailLine from '~/components/MailLine'

export default {
  name: 'cart-view',
  metaInfo () {
    return { title: this.$t('inbox') }
  },
  components: {
    'page-title': PageTitle,
    'mail-line': MailLine
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('member', [
      'inbox'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    }
  },
  async created () {
    await this.$store.dispatch('member/fetchInbox')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inbox.vue